import React from 'react'
import { Grid } from '@material-ui/core'
import { useStyles } from './NotFoundTemplate.styles'
import { Link } from 'components/ui/Behaviors/Link'
import { Image } from 'components/ui/DataDisplay/Image'
import { useLanguage } from 'store/locale/hooks/useLanguage'

export const NotFoundTemplate = ({ main1, main2, sub1, sub2 }) => {
  const { language } = useLanguage()
  const classes = useStyles()
  return (
    <Grid className={classes.root} container direction={'column'} spacing={2}>
      <Grid item xs={12}>
        <p className={classes.styled404}>
          4<span>0</span>4
        </p>
      </Grid>
      <Grid container item className={classes.titleWrapper}>
        <Grid item>
          <h1>
            {main1}
            <span>{main2}</span>
          </h1>
        </Grid>
        <Grid item>
          <h2>
            {sub1}
            <span>{sub2}</span>
          </h2>
        </Grid>
      </Grid>
      <Grid container item className={classes.linkWrapper}>
        <Link route={`/${language}`}>
          <Image height={'2rem'} backgroundUrl={'/assets/pictos/long-arrow-right.svg'} highlightable={false} />
        </Link>
      </Grid>
    </Grid>
  )
}
